import React, {useState} from "react";
import {FaChevronDown, FaLock} from "react-icons/fa";
import {AccountMedData, bloodTypeLabels, Sexuality} from "../../models/accountMedData";
import {t} from "i18next";
import ViewLocked from "../components/ViewLocked";

interface MedicalDataViewProps {
    medData: AccountMedData | null;
}

// Geschlechts-Mapping (analog zu deiner Edit-Komponente)
const getSexLabel = (value: Sexuality) =>
    t(`contact.fields.sex${value.charAt(0) + value.slice(1).toLowerCase()}`);

function MedicalDataView({medData}: MedicalDataViewProps) {
    const [open, setOpen] = useState(false);

    // 🔒 Keine Daten freigegeben
    if (!medData) {
        return (
            <ViewLocked message={t("common.messages.noSharedData")}/>
        );
    }

    return (
        <div className="view-container">
            {/* Header */}
            <div className="view-header" onClick={() => setOpen(!open)}>
                <div className="view-header-spacer"/>
                <h3 className="view-title">{t("menu.medical")}</h3>
                <FaChevronDown className={`view-arrow ${open ? "open" : ""}`}/>
            </div>

            {/* Inhalt */}
            {open && (
                <div className="view-content">

                    <div className="view-field">
                        <span className="label">{t("contact.fields.birthDate")}</span>
                        <span className="value">{medData.birthDate || "–"}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("contact.fields.sex")}</span>
                        <span className="value">
                            {getSexLabel(medData.sex)}
                        </span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("medical.fields.bloodType")}</span>
                        <span className="value">
                            {medData.bloodType
                                ? bloodTypeLabels[medData.bloodType]
                                : "–"}
                        </span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("medical.fields.meds")}</span>
                        <span className="value">{medData.meds || "–"}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("medical.fields.allergies")}</span>
                        <span className="value">{medData.allergies || "–"}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("medical.fields.preExistingConditions")}</span>
                        <span className="value">{medData.preExistingConditions || "–"}</span>
                    </div>

                </div>
            )}
        </div>
    );
}

export default MedicalDataView;